import { Component, OnInit, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import { FormBuilder } from "@angular/forms";
import { CustomerService } from '../_services/customer.service';
import { DebtorService } from '../_services/debtor.service';
import { InvoicesService } from '../_services/invoices.service';
import { MatSort, MatPaginator, MatTableDataSource } from '@angular/material';
import { ExcelService } from '../_helpers/index';

import { ParameterData } from '../_helpers/index';
import { Router } from '@angular/router';
import { Status, Overduedate, ExpirationRank, Creation } from '../_enums/invoice';
import { DataService } from '../_helpers/dataservice.service'
import { Invoice, Account, Debtor, Amount, Order, User } from '../_models';
import { AuthService } from '../_services/auth.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

import { Title } from '@angular/platform-browser';
import * as moment from 'moment';

import * as XLSX from 'xlsx';
type AOA = any[][];
import { AppConfig } from '../_helpers/index';

@Component({
  selector: 'invoiceimport',
  templateUrl: './invoiceimport.component.html',
  styleUrls: ['../../assets/css/customer-list-table.css']
})
export class InvoiceImportComponent implements OnInit {

  displayedColumns: string[] = ['external_id', 'order_id', 'name', 'order_description', 'clientid', 'clientemail', 'currency', 'value', 'due_datetime', 'expiration_datetime'];
  displayedColumnsProcessed: string[] = ['external_id', 'order_id', 'name', 'order_description', 'clientid', 'clientemail', 'currency', 'value', 'due_datetime', 'expiration_datetime'];


  dataSource = new MatTableDataSource();
  dataSourceProcessed = new MatTableDataSource();
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  data: any;
  excelHeader: any;
  uploadedFileName: any;

  tab1ActiveStatus: any;
  tab2ActiveStatus: any;
  tab3ActiveStatus: any;
  tab1Visibility: any;
  tab2Visibility: any;
  tab3Visibility: any;
  tab3ErrorVisibility: any;
  excelRowsFetchedCount: any;
  excelRowsProcessedCount: any;
  excelRowsNotProcessedCount: any;
  processStatus: any;
  processStatusText: any;
  errorInvoiceExport: any;
  enableImportExcel: boolean;
  customerPuplic_key: any;
  user_public_id: any;
  debtorData: any;

  public arrFinalData = [];
  public arrFinalStatusWithData = [];

  invoiceObj = {} as Invoice;
  object_tempStatus = {};
  public customerList = [];
  offsetTimeZone: any;
  offsetMinutes: any;
  offsetTimeVal: any;

  constructor
    (
      private router: Router, private formBuilder: FormBuilder
      , private _fb: FormBuilder, private excelService: ExcelService
      , private parameterData: ParameterData, private dataService: DataService
      , private customerService: CustomerService, private debtorService: DebtorService
      , private invoicesService: InvoicesService
      , private creation: Creation
      , private expirationRank: ExpirationRank
      , private overduedate: Overduedate
      , private status: Status
      , private datePipe: DatePipe
      , private auth: AuthService
      , private spinnerService: Ng4LoadingSpinnerService
      , private titleService: Title
    ) {


  }//end const


  ngOnInit() {

    var tempBrowserStorage;

    let browserStorage1 = (localStorage.getItem('isCorporate') == 'undefined') ? null : localStorage;
    if (browserStorage1 == null) {
      let browserStorage = localStorage.getItem('companyId');
      if (browserStorage == null || browserStorage == '' || browserStorage == undefined) {
        this.router.navigate(['/home']);
      }
      else {
        this.customerPuplic_key = localStorage.getItem('companyId');
        this.user_public_id = localStorage.getItem('userId');

      }
    }
    else {
      this.customerPuplic_key = localStorage.getItem('subcompanyId');
      this.user_public_id = localStorage.getItem('userId');
    }

    tempBrowserStorage = (typeof localStorage === 'undefined') ? null : localStorage;
    this.offsetTimeZone = (typeof tempBrowserStorage.getItem('timezone') === 'undefined') ? null : tempBrowserStorage.getItem('timezone');
        if (this.offsetTimeZone == null || this.offsetTimeZone === 'undefined' || Number.isNaN(this.offsetTimeZone)) {

            this.offsetTimeZone = -5.00;
            this.offsetMinutes = 0;
            this.offsetTimeVal = (this.offsetTimeZone * 3600000);
            AppConfig.settings.userSetting.defaultTimeZone = this.offsetTimeVal;
        }
        else {

            this.offsetTimeZone = tempBrowserStorage.getItem('timezone');
            this.offsetMinutes = 0;

            this.offsetTimeVal = (this.offsetTimeZone * 3600000);
            AppConfig.settings.userSetting.defaultTimeZone = this.offsetTimeVal;


        }

    this.invoiceObj.total = {} as Amount;
    this.invoiceObj.metadata = {} as Order;
    this.invoiceObj.debtor = {} as Debtor;



    this.enableImportExcel = false;
    this.tab1ActiveStatus = "active";
    this.tab2ActiveStatus = "disabled";
    this.tab3ActiveStatus = "disabled";
    this.tab1Visibility = true;
    this.tab2Visibility = false;
    this.tab3Visibility = false;
    this.uploadedFileName = "Archivo a subir";


    this.excelRowsFetchedCount = Number(0);
    this.excelRowsProcessedCount = Number(0);
    this.excelRowsNotProcessedCount = Number(0);
    this.GetCustomerDetails();

  }//end ngoninit


  isDate(ExpiryDate) {



    var objDate,  // date object initialized from the ExpiryDate string 
      mSeconds, // ExpiryDate in milliseconds 
      day,      // day 
      month,    // month 
      year;     // year 
    // date length should be 10 characters (no more no less) 
    if (ExpiryDate.length !== 10) {
      return false;
    }
    // third and sixth character should be '/' 
    if (ExpiryDate.substring(2, 3) !== '/' || ExpiryDate.substring(5, 6) !== '/') {

      return false;
    }


    // extract month, day and year from the ExpiryDate (expected format is mm/dd/yyyy) 
    // subtraction will cast variables to integer implicitly (needed 
    // for !== comparing) 
    month = ExpiryDate.substring(0, 2) - 1; // because months in JS start from 0 
    day = ExpiryDate.substring(3, 5) - 0;
    year = ExpiryDate.substring(6, 10) - 0;

    // test year range 
    if (year < 1000 || year > 3000) {
      return false;
    }
    // convert ExpiryDate to milliseconds 
    mSeconds = (new Date(year, month, day)).getTime();
    // initialize Date() object from calculated milliseconds 
    objDate = new Date();
    objDate.setTime(mSeconds);
    // compare input date and parts from Date() object 
    // if difference exists then date isn't valid 
    if (objDate.getFullYear() !== year ||
      objDate.getMonth() !== month ||
      objDate.getDate() !== day) {
      return false;
    }
    // otherwise return true 


    return true;
  }

  isDateFormat(serial) {

    try {

      if (serial.match(/^(\d{1})\/(\d{2})\/(\d{4})$/)) {

        var t = serial.match(/^(\d{1})\/(\d{2})\/(\d{4})$/);
        if (t === null) return false;
        var d = parseInt(t[1]), m = parseInt(t[2], 10);
        //below should be more acurate algorithm
        if (m >= 1 && m <= 12 && d >= 1 && d <= 31) {

          return true;
        }
        return false;
      }
      else if (serial.match(/^(\d{2})\/(\d{1})\/(\d{4})$/)) {

        var td = serial.match(/^(\d{2})\/(\d{1})\/(\d{4})$/);
        if (td === null) return false;
        var d1 = parseInt(td[1]), m1 = parseInt(td[2], 10);
        //below should be more acurate algorithm
        if (m1 >= 1 && m <= 12 && d1 >= 1 && d1 <= 31) {

          return true;
        }
        return false;
      }
    }
    catch
    {
      return false
    }
  }


  ExcelDateToJSDate(serial) {

    if (this.isDate(serial)) {

      var separators = [' ', '\\\+', '-', '\\\(', '\\\)', '\\*', '/', ':', '\\\?'];
      var tokens = serial.split(new RegExp(separators.join('|'), 'g'));

      var date1 = new Date(parseInt(tokens[2], 10),
        parseInt(tokens[1], 10) - 1,
        parseInt(tokens[0], 10),
      );





      var momentObj = moment(date1);

      var momentString = momentObj.format('MM/DD/YYYY hh:mm:ss');

      return momentString;


    }
    else {

      if (this.isDateFormat(serial)) {

        var separators1 = [' ', '\\\+', '-', '\\\(', '\\\)', '\\*', '/', ':', '\\\?'];
        var tokens1 = serial.split(new RegExp(separators1.join('|'), 'g'));

        var date2 = new Date(parseInt(tokens1[2], 10),
          parseInt(tokens1[1], 10) - 1,
          parseInt(tokens1[0], 10),
        );





        var momentObj1 = moment(date2);

        var momentString1 = momentObj1.format('MM/DD/YYYY hh:mm:ss');

        return momentString1;

      }
      else {
        // var utc_days = Math.floor(serial - 25569);
        // var utc_value = utc_days * 86400;
        // var date_info = new Date(utc_value * 1000);
        // var fractional_day = serial - Math.floor(serial) + 0.0000001;
        // var total_seconds = Math.floor(86400 * fractional_day);
        // var seconds = total_seconds % 60;
        // total_seconds -= seconds;
        // var hours = Math.floor(total_seconds / (60 * 60));
        // var minutes = Math.floor(total_seconds / 60) % 60;

        //  return new Date(date_info.getFullYear(), date_info.getMonth(), date_info.getDate(), hours, minutes, seconds);
      // return new Date(Math.round((serial - 25569)*86400*1000));
        //return new Date((serial - (25567 + 2))*86400*1000);
        var days = Math.floor(serial);
        var hours = Math.floor((serial % 1) * 24);
        var minutes = Math.floor((((serial % 1) * 24) - hours) * 60)
        return new Date(Date.UTC(0, 0, serial, hours-15, minutes));
      }
    }




  }




  onFileChange(evt: any) {

    this.spinnerService.show();
    this.enableImportExcel = true;

    /* wire up file reader */
    const target: DataTransfer = <DataTransfer>(evt.target);
    if (target.files.length !== 1) throw new Error('Cannot use multiple files');

    this.uploadedFileName = target.files[0].name;

    if (target.files.length == 1 && (target.files[0].type == ".xlsx" || target.files[0].type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || target.files[0].type == "application/vnd.ms-excel")) {
      const reader: FileReader = new FileReader();
      reader.onload = (e: any) => {
        /* read workbook */
        const bstr: string = e.target.result;
        const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

        /* grab first sheet */
        const wsname: string = wb.SheetNames[0];
        const ws: XLSX.WorkSheet = wb.Sheets[wsname];

        this.data = (XLSX.utils.sheet_to_json(ws, { header: 1 }));

      };
      reader.readAsBinaryString(target.files[0]);
    }
    else {
      this.enableImportExcel = false;
      this.errorInvoiceExport = "Error al intentar abrir el archivo ! ";

    }
    this.spinnerService.hide();
  }//end onfilechange


  Executeagain() {
    this.tab1Visibility = true;
    this.tab2Visibility = false;
    this.tab3Visibility = false;
    this.tab1ActiveStatus = "active";
    this.tab2ActiveStatus = "disabled";
    this.tab3ActiveStatus = "disabled";
    this.tab3ErrorVisibility = false;
    this.uploadedFileName = '';
  }


  checkEx(BiddingClosedDate) {



    var separators = [' ', '\\\+', '-', '\\\(', '\\\)', '\\*', '/', ':', '\\\?'];
    var tokens = BiddingClosedDate.split(new RegExp(separators.join('|'), 'g'));

    var date = new Date(parseInt(tokens[0], 10),
      parseInt(tokens[1], 10) - 1,
      parseInt(tokens[2], 10),
    );

    return date;
  }

  importExcelData(evt: any) {

    this.excelHeader = this.data[0];

    var jsonObjectKeys = ['external_id', 'order_id', 'name', 'order_description', 'clientid', 'clientemail', 'currency', 'value', 'due_datetime', 'expiration_datetime'];

    if (this.excelHeader.length == 10) {
      for (var i = 1; i <= this.data.length - 1; i++) {
        var object_temp = {};
        for (var j = 0; j < this.excelHeader.length; j++) {
          object_temp[jsonObjectKeys[j]] = this.data[i][j];

        }//end for j

        if ((object_temp["external_id"] != '' && object_temp["external_id"] != null && object_temp["external_id"] != undefined) && (object_temp["name"] != '' && object_temp["name"] != null && object_temp["name"] != undefined)) {

          var duedate = moment(object_temp["due_datetime"]);





          if (duedate.isValid()) {


            object_temp["due_datetime"] = (this.ExcelDateToJSDate(object_temp["due_datetime"]) == "Invalid Date") ? "Invalid" : this.ExcelDateToJSDate(object_temp["due_datetime"]);

          }
          else {


            object_temp["due_datetime"] = "Invalid Date"

          }



          var expdate = moment(object_temp["expiration_datetime"]);



          if (expdate.isValid()) {


            object_temp["expiration_datetime"] = (this.ExcelDateToJSDate(object_temp["expiration_datetime"]) == "Invalid Date") ? "Invalid" : this.ExcelDateToJSDate(object_temp["expiration_datetime"]);


          }
          else {


            object_temp["expiration_datetime"] = "Invalid Date"


          }

          object_temp["external_id"] = object_temp["external_id"].toString();
          object_temp["order_description"] = object_temp["order_description"].toString();
          this.arrFinalData.push(object_temp);
        }

      }//end for i

      this.excelRowsFetchedCount = this.arrFinalData.length;
      this.dataSource.data = this.arrFinalData;
      this.dataSourceProcessed.data = this.arrFinalData;


      this.tab1Visibility = false;
      this.tab2Visibility = true;
      this.tab3Visibility = false;
      this.tab1ActiveStatus = "disabled";
      this.tab2ActiveStatus = "active";
      this.tab3ActiveStatus = "disabled";
      this.tab3ErrorVisibility = false;
    }
    else {
      this.tab1Visibility = false;
      this.tab2Visibility = false;
      this.tab3Visibility = true;
      this.tab1ActiveStatus = "disabled";
      this.tab2ActiveStatus = "disabled";
      this.tab3ActiveStatus = "active";
      this.tab3ErrorVisibility = true;

    }
    this.spinnerService.hide();
  }//end importExcelData

  private handleErrorPromise(handleError: Response | any) {

    return Promise.reject(handleError.message || handleError);
  }

  GetCustomerDetails() {
    this.customerService.getCustomerDebtorsForImport(this.customerPuplic_key).subscribe(data => {
      let resources = data["body"]["data"];
      this.customerList = resources;
    },
      error => {
        console.log('Failed while trying to the Customer Search All Result. ' + error);
      });
  }

  confirmData() {
    
    for (var i = 0; i <= this.arrFinalData.length - 1; i++) {

      var debtorobj = this.arrFinalData[i];
      var tempCustomerList = this.customerList.filter(item => item.email == this.arrFinalData[i].clientemail && item.external_id == this.arrFinalData[i].clientid);
      var tempCustomerStatus = false;
      if (tempCustomerList.length > 0) {
        for (var k = 0; k < tempCustomerList.length; k++) {
          if (tempCustomerList[k].status == "INACTIVE") {
            tempCustomerStatus = true;
          }
        }
      }
      const debtorPromiseResult = this.debtorService.searchDebtorPromise(this.customerPuplic_key, this.arrFinalData[i].clientemail, this.arrFinalData[i].clientid.toString());

      if (debtorobj.due_datetime == "Invalid Date" || debtorobj.expiration_datetime == "Invalid Date" || debtorobj.due_datetime == "Invalid" || debtorobj.expiration_datetime == "Invalid") {

        this.createInvoiceDetailsFailureInvalidDateData("Error", debtorobj, i);
      }
      else if (debtorobj.due_datetime == "Invalid Date" && debtorobj.expiration_datetime == "Invalid Date" && debtorobj.due_datetime == "Invalid" && debtorobj.expiration_datetime == "Invalid") {
        this.createInvoiceDetailsFailureInvalidDateData("Error", debtorobj, i);
      }
      else if (tempCustomerStatus) {
        this.createInvoiceDetailsFailureInActiveCustomer("Error", debtorobj, i);
      }
      else {

        debtorPromiseResult.then(
          this.bindInvoiceDetails.bind(this, [this.arrFinalData[i], i])
        )
          .catch(error => {

            this.createInvoiceDetailsFailureData(error, debtorobj, 0);
          });
      }
    }//end for

    this.tab1Visibility = false;
    this.tab2Visibility = false;
    this.tab3Visibility = true;
    this.tab1ActiveStatus = "disabled";
    this.tab2ActiveStatus = "disabled";
    this.tab3ActiveStatus = "active";
    this.tab3ErrorVisibility = false;
    window.scroll(0, 0);

  }//end confirm Data



  bindInvoiceDetails(arrParams: any, searchDebtorResult: any) {
    var invoiceObj = {} as Invoice;
    invoiceObj.total = {} as Amount;
    invoiceObj.metadata = {} as Order;
    invoiceObj.debtor = {} as Debtor;
    invoiceObj.user = {} as User;

    invoiceObj.invoice_id = arrParams[0].external_id.toString();
    invoiceObj.user.public_id = this.user_public_id;
    invoiceObj.metadata.order_id = arrParams[0].order_id.toString();
    invoiceObj.metadata.order_name = arrParams[0].name;
    invoiceObj.metadata.order_description = arrParams[0].order_description;
    invoiceObj.debtor.public_id = (searchDebtorResult.data[0] == undefined || searchDebtorResult.data[0] == null || searchDebtorResult.data[0] == '') ? '' : searchDebtorResult.data[0].public_id;
    invoiceObj.total.currency = arrParams[0].currency;
    invoiceObj.total.value = (arrParams[0].value == undefined || arrParams[0].value == null || arrParams[0].value == '') ? 0 : Number(arrParams[0].value);


    var due_datetime_momentobj = moment(arrParams[0].due_datetime);
    var temp_dueDate = due_datetime_momentobj.format("YYYY-MM-DD 00:00:00");
    invoiceObj.due_datetime = this.convertGMTTime(temp_dueDate);

    // var tmpdue_Date = new Date(arrParams[0].due_datetime);
    // invoiceObj.due_datetime = tmpdue_Date.toISOString();

    var exp_datetime_momentobj = moment(arrParams[0].expiration_datetime);
    var temp_expDate = exp_datetime_momentobj.format("YYYY-MM-DD 00:00:00");
    invoiceObj.expiration_datetime = this.convertGMTTime(temp_expDate);

    // var tmpexp_Date = new Date(arrParams[0].expiration_datetime);
    // invoiceObj.expiration_datetime = tmpexp_Date.toISOString();

    const invoiceCreditorPromiseResult = this.customerService.getCustomerAccountListPromise(this.customerPuplic_key);
    invoiceCreditorPromiseResult.then(
      this.bindInvoiceDetailsAll.bind(this, [invoiceObj, arrParams[1]])
    )


  }//end temp


  bindInvoiceDetailsAll(value1: any, customerAccListResult: any) {

    var totalcurrency: any;
    var late_feecurrency: any;

    var invoiceObj = {} as Invoice;
    var creditor_account = {} as Account;
    invoiceObj = value1[0];


    var cusAccountPublicKey_temparr = customerAccListResult;
    cusAccountPublicKey_temparr = cusAccountPublicKey_temparr.filter((t => t.type == 'COLLECT' || t.type == 'RECEIVABLE'));
    cusAccountPublicKey_temparr = cusAccountPublicKey_temparr.filter((t => t.balance.currency == value1[0].total.currency));

    if(cusAccountPublicKey_temparr.length > 0) {
    var cusAccountPublicKey_temp = cusAccountPublicKey_temparr[0].public_id;
    creditor_account.public_id = cusAccountPublicKey_temp;
    invoiceObj.creditor_account = creditor_account;



    const invoiceCreatePromiseResult = this.invoicesService.createInvoicePromise(invoiceObj);
    invoiceCreatePromiseResult.then(
      this.createInvoiceDetailsSuccessData.bind(this, [invoiceObj, value1[1]])
    )
      .catch(error => {

        this.createInvoiceDetailsFailureData(error, invoiceObj, value1[1]);
      });
    }
    else {
      this.createInvoiceDetailsFailure('Accounts not available', invoiceObj, value1[1]);
    }
  }//end


  createInvoiceDetailsSuccessData(arrparams: any, createdinvoice: any) {
    this.excelRowsProcessedCount = this.excelRowsProcessedCount + 1;
    this.bindInvoiceDetailsExcelData(createdinvoice, 'SI', 'Invoice Created', arrparams[1]);
  }//end


  createInvoiceDetailsFailureData(errorval: any, invoiceobj: any, iVal: any) {

    this.excelRowsNotProcessedCount = this.excelRowsNotProcessedCount + 1;
    this.bindInvoiceDetailsExcelData(invoiceobj, 'NO', errorval.error, iVal);
  }//end

  createInvoiceDetailsFailure(errorval: any, invoiceobj: any, iVal: any) {

    this.excelRowsNotProcessedCount = this.excelRowsNotProcessedCount + 1;
    this.bindInvoiceDetailsExcelData(invoiceobj, 'NO', errorval, iVal);
  }
  createInvoiceDetailsFailureInvalidDateData(errorval: any, invoiceobj: any, iVal: any) {

    this.excelRowsNotProcessedCount = this.excelRowsNotProcessedCount + 1;
    this.bindInvoiceDetailsExcelData(invoiceobj, 'NO', "Invalid Date", iVal);
  }//end
  createInvoiceDetailsFailureInActiveCustomer(errorval: any, invoiceobj: any, iVal: any) {

    this.excelRowsNotProcessedCount = this.excelRowsNotProcessedCount + 1;
    this.bindInvoiceDetailsExcelData(invoiceobj, 'NO', "InActive Customer", iVal);
  }


  bindInvoiceDetailsExcelData(invoiceobj: any, status: any, statusText: any, iVal: any) {
    var jsonObjectKeysStatus = ['external_id', 'order_id', 'name', 'order_description', 'clientid', 'clientemail', 'currency', 'value', 'due_datetime', 'expiration_datetime', 'processed', 'statustext']
    var object_tempStatus = {};

    for (var l = 0; l < this.excelHeader.length; l++) {
      if (l == this.excelHeader.length - 1) {
        object_tempStatus[jsonObjectKeysStatus[l]] = this.data[iVal + 1][l];
        object_tempStatus["processStatus"] = status;
        object_tempStatus["processStatusText"] = statusText;
      }
      else {
        object_tempStatus[jsonObjectKeysStatus[l]] = this.data[iVal + 1][l];
      }
    }//end for l


    this.arrFinalStatusWithData.push(object_tempStatus);


  }//end temp


  downloadResultAsXLSX() {
    this.setExportExcelFileData(this.arrFinalStatusWithData);
  }//end


  setExportExcelFileData(excelExportData) {
    var excelHeader = ["ID Orden de Pago", "REFERENCIA", "NOMBRE", "DESCRIPCION", "ID CLIENTE (*)", "EMAIL DEL CLIENTE (*)", "MONEDA", "MONTO", "VENCIMIENTO", "EXPIRACION", "PROCESADO", "ESTADO"]
    var jsonObjectKeys = ['external_id', 'order_id', 'name', 'order_description', 'clientid', 'clientemail', 'currency', 'value', 'due_datetime', 'expiration_datetime', 'processStatus', 'processStatusText']

    var arrFinalData = [];
    var object_temp = {};
    var i = 0;
    var columnsKeyNames = [];

    for (i = 0; i < excelExportData.length; i++) {
      var singleRec_temp = excelExportData[i];

      var externalid_temp;
      var orderid_temp;
      var name_temp;
      var description_temp;
      var clientid_temp;
      var email_temp;
      var currency_temp;
      var value_temp;
      var duedate_temp;
      var expdate_temp;
      var processstatus_temp;
      var status_temp;

      columnsKeyNames = Object.keys(singleRec_temp);

      object_temp = {};

      for (var j = 0; j < columnsKeyNames.length; j++) {


        if (jsonObjectKeys[j] == "external_id") {
          externalid_temp = singleRec_temp[jsonObjectKeys[j]];
        }
        if (jsonObjectKeys[j] == "order_id") {
          orderid_temp = singleRec_temp[jsonObjectKeys[j]];
        }
        if (jsonObjectKeys[j] == "name") {
          name_temp = singleRec_temp[jsonObjectKeys[j]];
        }

        if (jsonObjectKeys[j] == "order_description") {
          description_temp = singleRec_temp[jsonObjectKeys[j]];
        }

        if (jsonObjectKeys[j] == "clientid") {
          clientid_temp = singleRec_temp[jsonObjectKeys[j]];
        }

        if (jsonObjectKeys[j] == "clientemail") {
          email_temp = singleRec_temp[jsonObjectKeys[j]];
        }

        if (jsonObjectKeys[j] == "currency") {
          currency_temp = singleRec_temp[jsonObjectKeys[j]];
        }


        if (jsonObjectKeys[j] == "value") {
          value_temp = singleRec_temp[jsonObjectKeys[j]];
        }

        if (jsonObjectKeys[j] == "due_datetime") {


          var duedate = moment(singleRec_temp[jsonObjectKeys[j]]);

          if (duedate.isValid()) {
            var datedue = this.ExcelDateToJSDate(singleRec_temp[jsonObjectKeys[j]]);

            var momentObj = moment(datedue);

            var momentStringDue = momentObj.format('MM/DD/YYYY');

            duedate_temp = momentStringDue;
          }
          else {

            duedate_temp = singleRec_temp[jsonObjectKeys[j]];
          }

        }

        if (jsonObjectKeys[j] == "expiration_datetime") {

          var expdate = moment(singleRec_temp[jsonObjectKeys[j]]);

          if (expdate.isValid()) {
            var dateexp = this.ExcelDateToJSDate(singleRec_temp[jsonObjectKeys[j]]);
            var expirationMomentObj = moment(dateexp);

            var momentStringExp = expirationMomentObj.format('MM/DD/YYYY');

            expdate_temp = momentStringExp;
          }
          else {

            expdate_temp = singleRec_temp[jsonObjectKeys[j]];
          }

        }

        if (jsonObjectKeys[j] == "processStatus") {
          processstatus_temp = singleRec_temp[jsonObjectKeys[j]];
        }

        if (jsonObjectKeys[j] == "processStatusText") {
          status_temp = singleRec_temp[jsonObjectKeys[j]];
        }

      }

      for (var m = 0; m < excelHeader.length; m++) {
        if (excelHeader[m] == "ID EMPRESA" || excelHeader[m] == "ID Orden de Pago") {
          object_temp[excelHeader[m]] = externalid_temp;
        }

        if (excelHeader[m] == "REFERENCIA") {
          object_temp[excelHeader[m]] = orderid_temp;
        }

        if (excelHeader[m] == "NOMBRE") {
          object_temp[excelHeader[m]] = name_temp;
        }
        if (excelHeader[m] == "DESCRIPCION") {
          object_temp[excelHeader[m]] = description_temp;
        }

        if (excelHeader[m] == "ID CLIENTE (*)") {
          object_temp[excelHeader[m]] = clientid_temp;
        }

        if (excelHeader[m] == "EMAIL DEL CLIENTE (*)") {
          object_temp[excelHeader[m]] = email_temp;
        }

        if (excelHeader[m] == "MONEDA") {
          object_temp[excelHeader[m]] = currency_temp;
        }

        if (excelHeader[m] == "MONTO") {
          object_temp[excelHeader[m]] = value_temp;
        }
        if (excelHeader[m] == "VENCIMIENTO") {
          object_temp[excelHeader[m]] = duedate_temp;




        }


        if (excelHeader[m] == "EXPIRACION") {
          object_temp[excelHeader[m]] = expdate_temp;



        }


        if (excelHeader[m] == "PROCESADO") {
          object_temp[excelHeader[m]] = processstatus_temp;
        }

        if (excelHeader[m] == "ESTADO") {
          object_temp[excelHeader[m]] = status_temp;
        }


      }//end for

      arrFinalData.push(object_temp);
    }


    this.excelService.exportAsExcelFile(arrFinalData, 'ImportedInvoiceList');


  }//end function



/****GMT Converstion */
convertGMTTime(convertDate) {
  var dateTimeZoneDiff = convertDate.split(/[- :]/),
      startDateFinal = new Date(dateTimeZoneDiff[0], dateTimeZoneDiff[1] - 1, dateTimeZoneDiff[2], dateTimeZoneDiff[3], dateTimeZoneDiff[4], dateTimeZoneDiff[5]);
  if (this.offsetTimeZone > 0) {
      this.offsetMinutes = 30;
      var startDate2 = new Date(startDateFinal.setHours(startDateFinal.getHours() - this.offsetTimeZone));
      var startDate3 = new Date(startDate2.setMinutes(startDate2.getMinutes() - this.offsetMinutes) + 720000);
      let tempDate = moment(startDate3).format('YYYY-MM-DD HH:mm:ss');
      return tempDate;
  }
  else {
      var startDate4 = new Date(startDateFinal.setHours(startDateFinal.getHours() - this.offsetTimeZone));
      var startDate5 = new Date(startDate4.setMinutes(startDate4.getMinutes() - this.offsetMinutes));
      let tempDate1 = moment(startDate5).format('YYYY-MM-DD HH:mm:ss');
      return tempDate1;
  }


}


}//end class